import { useState } from 'react';
import { Link, useParams } from 'react-router';
import { api } from '../../shared/api/client';
import { Alert, ErrorState, Loading, Logo } from '../../shared/ui/components';
import { useAsync } from '../../shared/ui/useAsync';
import { VisitorForm } from './VisitorForm';

/** Registro de visitante sin cuenta (enlace o QR en la entrada). */
export function PublicVisitorPage() {
  const { slug = '' } = useParams();
  const info = useAsync((signal) => api.get<{ churchName: string }>(`/multichurch/public/${encodeURIComponent(slug)}/visitors`, signal), [slug]);
  const [done, setDone] = useState<string | null>(null);
  return (
    <div className="landing">
      <header className="landing__bar">
        <Link to="/" aria-label="KEORA">
          <Logo />
        </Link>
      </header>
      <main className="public public-event">
        {info.status === 'loading' ? <Loading /> : null}
        {info.status === 'error' ? <ErrorState error={info.error} /> : null}
        {info.status === 'ready' ? (
          done ? (
            <>
              <h1>¡Gracias, {done}!</h1>
              <Alert tone="success">Nos da mucho gusto que nos visites. Alguien de {info.data.churchName} te saludará.</Alert>
              <div className="actions actions--wrap">
                <Link className="btn btn--primary" to={`/i/${encodeURIComponent(slug)}`}>
                  Ver la página de la iglesia
                </Link>
                <Link className="btn btn--secondary" to="/registro">
                  Crear mi cuenta
                </Link>
              </div>
            </>
          ) : (
            <>
              <p className="eyebrow">{info.data.churchName}</p>
              <h1>¡Bienvenido!</h1>
              <p className="muted">Déjanos tus datos para darte la bienvenida. Solo el nombre es obligatorio.</p>
              <p className="visit-note small">
                <span aria-hidden="true">ℹ️</span> Esto no es crear una cuenta: solo nos avisas que nos visitas. Si después quieres ser parte de la iglesia,
                tus datos ya estarán listos. ¿Buscas tu cuenta de KEORA? <Link to="/registro">Créala aquí</Link>.
              </p>
              <VisitorForm
                publicForm
                submitLabel="Enviar"
                onSubmit={async (v) => {
                  await api.post(`/multichurch/public/${encodeURIComponent(slug)}/visitors`, v);
                  setDone(v.givenName);
                }}
              />
            </>
          )
        ) : null}
      </main>
    </div>
  );
}
